/** Static copy shared by booking and ticket screens (from the mobile app's `Constants`). */
export const CANCELLATION_RULES: readonly string[] = [
  'از زمان پرداخت هزینه سفر بین‌شهری تا یک ساعت قبل از حرکت ۱۰ درصد مبلغ پرداختی کسر و الباقی حداکثر تا ۴۸ ساعت به حساب کاربر استرداد خواهد شد.',
  'در بازه زمانی یک ساعت مانده به حرکت ۵۰ درصد مبلغ پرداختی کسر و الباقی حداکثر تا ۴۸ ساعت به حساب کاربر استرداد خواهد شد.',
  'پس از ساعت حرکت امکان کنسل و استرداد وجه پرداختی وجود ندارد مگر توسط شرکت مسافربری ارائه‌دهنده سرویس.',
  'در صورت تغییر شرایط و مقررات کنسلی بر اساس اعلام شرکت‌های مسافربری، در زمان خرید به اطلاع مسافرین می‌رسد و بلینو مسئولیتی بابت آن ندارد.',
  'در صورت هرگونه مغایرت در تعداد و هویت مسافرین در زمان حرکت خودرو، امکان کنسل و استرداد وجه وجود ندارد و مسئولیت آن با خریدار می‌باشد.',
];

export const TERMS_URL = 'https://api.blino.ir/api/passenger/rules';
/** Seats/vehicle are held for this long after the "lock" call. */
export const LOCK_MINUTES = 15;

/** Public contact details — carried over from the previous tracking site's footer/contact page. */
export const SUPPORT = {
  phone: '09005520153',
  phoneDisplay: '۰۹۰۰۵۵۲۰۱۵۳',
  email: 'blinocompany05@gmail.com',
  city: 'کرمان، ایران',
  social: {
    bale: 'https://ble.ir/blino_support',
    eitaa: 'https://eitaa.com/blino_support',
    telegram: 'https://t.me/blino_support',
  },
} as const;

export const SITE_NAME = 'بلینو';
export const SITE_TAGLINE = 'حرکت، از اینجا شروع می‌شود';
export const SITE_SLOGAN = SITE_TAGLINE;
export const SITE_ALT_NAMES = ['Belino', 'Belino Bar', 'Belino Ticket', 'بلینو بار', 'مهاجر تیکت'] as const;
export const SITE_FULL_NAME = 'سامانه جامع سفر و بار بین‌شهری بلینو';
export const SITE_TITLE = 'بلینو | سامانه جامع خرید آنلاین بلیط تاکسی بین‌شهری و رهگیری بار';
export const SITE_DESCRIPTION = 'بلینو؛ سامانه رزرو و خرید آنلاین بلیط تاکسی سواری بین‌شهری (عادی و دربستی)، سفر درب‌به‌درب، ارسال و رهگیری سریع بار و مرسوله بین‌شهری.';
export const SITE_KEYWORDS = 'بلینو, خرید بلیط تاکسی بین شهری, تاکسی بین شهری, بلیط سواری بین شهری, سفر درب به درب, رهگیری مرسوله, ارسال بار بین شهری, تاکسی کرمان, تاکسی سیرجان, تاکسی رفسنجان, حمل بار بین شهری';
export const SITE_OG_IMAGE = 'https://blino.ir/og-image.png';
export const OG_IMAGE = SITE_OG_IMAGE;
export const SITE_URL = 'https://blino.ir';
export const SUPPORT_PHONE_E164 = '+989005520153';
